import { Classes, InputGroup } from "@blueprintjs/core";
import { Form, Formik } from "formik";
import { Buttons } from "modules/common/components/form";
import { StandardFormInput } from "modules/common/components/form/StandardFormInput";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import React, { useState } from "react";
import { SessionType } from "../models/session";
import AuthSchema from "./validation";
import styles from "./AuthForm.module.scss";

const schema = AuthSchema();

export const AuthForm = ({ store }: AuthFormProps) => {
    const prefilled = !!store.credentials.login;
    const ignoreManager = prefilled
        ? {
              autoComplete: "off",
              "data-lpignore": "true",
          }
        : {};

    // «Забыли пароль?» показываем только после неудачной попытки входа
    const [failed, setFailed] = useState(false);
    const [forgot, setForgot] = useState(false);
    const [resetLogin, setResetLogin] = useState("");
    const [sending, setSending] = useState(false);

    return (
        <Formik
            initialValues={getFormValues(store)}
            enableReinitialize={true}
            validationSchema={schema}
            onSubmit={async (model) => {
                const res = await store.logIn(model);
                if (res === false) {
                    setFailed(true);
                    setResetLogin(model.login ?? "");
                }
            }}
        >
            {() => {
                return (
                    <Form>
                        <div className={Classes.DIALOG_BODY}>
                            <StandardFormInput name="login" schema={schema} small={true} className="planr-form-input">
                                {({ field }) => (
                                    <InputGroup
                                        id="login"
                                        {...field}
                                        className="planr-default-input"
                                        {...ignoreManager}
                                    />
                                )}
                            </StandardFormInput>

                            <StandardFormInput
                                name="password"
                                schema={schema}
                                small={true}
                                className="planr-form-input"
                            >
                                {({ field }) => (
                                    <InputGroup
                                        id="password"
                                        {...field}
                                        className="planr-default-input"
                                        type="password"
                                        {...ignoreManager}
                                    />
                                )}
                            </StandardFormInput>
                            {failed && !forgot && (
                                <PlanrButton
                                    type="neutral"
                                    size="small"
                                    onClick={() => setForgot(true)}
                                    className={styles.forgotLink}
                                >
                                    Забыли пароль?
                                </PlanrButton>
                            )}
                            {forgot && (
                                <div className={styles.forgot}>
                                    <div className={styles.forgotHint}>
                                        Укажите логин или почту — пришлём ссылку, по которой можно задать новый пароль.
                                    </div>
                                    <InputGroup
                                        className="planr-default-input"
                                        value={resetLogin}
                                        placeholder="Логин или почта"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                            setResetLogin(e.currentTarget.value)
                                        }
                                    />
                                    <div className={styles.forgotActions}>
                                        <PlanrButton
                                            type="lightblueish"
                                            size="small"
                                            disabled={sending || !resetLogin.trim()}
                                            onClick={async () => {
                                                setSending(true);
                                                const ok = await store.requestPasswordReset(resetLogin.trim());
                                                setSending(false);
                                                if (ok) {
                                                    setForgot(false);
                                                }
                                            }}
                                        >
                                            Отправить ссылку
                                        </PlanrButton>
                                        <PlanrButton type="graybtn" size="small" onClick={() => setForgot(false)}>
                                            Отмена
                                        </PlanrButton>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className={Classes.DIALOG_FOOTER}>
                            <Buttons>
                                <PlanrButton type="blueish" nativeType="submit" icon="general-sign-in" size="small">
                                    Вход
                                </PlanrButton>
                            </Buttons>
                        </div>
                    </Form>
                );
            }}
        </Formik>
    );
};

export interface AuthFormProps {
    store: SessionType;
}

function getFormValues(store: SessionType) {
    return {
        login: store.credentials.login,
        password: store.credentials.password,
    };
}
